import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import Modal from '~/components/Modal/Modal';
import { useModal } from '~/hooks/useModal';

import { userStore } from '~/stores';

import Icon from '../Icon/Icon';

export default observer(() => {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await userStore.logout().catch((error) => error && console.error(error));
      navigate('/');
    } catch (e) {
      console.error(e);
    }
  };

  const backHandler = () => closeModal();

  return (
    <Modal
      isShow={true}
      className="modal-logout__body"
      onBackdropDismiss={backHandler}
    >
      <div className="popover-container input-form">
        <div className="popover">
          {!company.newDesignSystemEnabled && (
            <button
              className="button _no-padding _no-color input-form__back"
              onClick={backHandler}
            >
              <Icon type="arrow" className="icon__rotate-180" size={24} />
            </button>
          )}
          <button
            className="button _no-padding _no-color input-form__close"
            onClick={backHandler}
          >
            <Icon type="plus" className="icon__rotate-45" size={36} />
          </button>
          <div className="input-form__form">
            <div className="input-form__form-header">
              <p className="input-form__form-header-title">
                {t('phrases:wantToLogout')}
              </p>
            </div>
            <div className="input-form__form-footer">
              <div className="input-form__form-footer-buttons">
                <button className="button _bordered _med" onClick={backHandler}>
                  {t('goBack')}
                </button>
                <button className="button _primary _med" onClick={handleLogout}>
                  {t('logOut')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
});
